import React, { useState } from "react";
import { useApp } from "@/context/AppContext";
import { ccoreApi } from "@/lib/ccore";
import { Panel } from "@/components/common/Panel";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { MailOpen, Building2 } from "lucide-react";

export default function PendingInvitations() {
  const { ccore, reloadCcore, switchOrg } = useApp();
  const [busy, setBusy] = useState(null);
  const invites = ccore?.pendingInvites || [];

  const accept = async (inv) => {
    setBusy(inv.id);
    try {
      const res = await ccoreApi.acceptInvite({ id: inv.id });
      toast.success(`You joined ${inv.orgName}`);
      await reloadCcore();
      if (res?.membershipId) { try { await switchOrg(res.membershipId); } catch (e) { /* switch toast handled */ } }
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not accept invitation");
    } finally { setBusy(null); }
  };
  const reject = async (inv) => {
    setBusy(inv.id);
    try { await ccoreApi.rejectInvite({ id: inv.id }); toast.success("Invitation declined"); await reloadCcore(); }
    catch (err) { toast.error("Could not decline invitation"); }
    finally { setBusy(null); }
  };

  return (
    <Panel className="p-5" data-testid="pending-invitations-panel">
      <div className="flex items-center gap-2"><MailOpen className="h-4 w-4 text-copper" /><h3 className="font-display text-lg font-semibold text-ink">My invitations</h3></div>
      <p className="mt-1 text-sm text-ink-2">Invitations addressed to your account email.</p>
      {invites.length === 0 ? (
        <p className="mt-4 text-sm text-ink-muted" data-testid="pending-invites-empty">You have no pending invitations.</p>
      ) : (
        <div className="mt-4 space-y-3">
          {invites.map((inv) => (
            <div key={inv.id} className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-line bg-card p-4" data-testid={`my-invite-${inv.id}`}>
              <div className="flex items-center gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-copper/10"><Building2 className="h-5 w-5 text-copper" /></div>
                <div>
                  <div className="font-medium text-ink">{inv.orgName}</div>
                  <div className="text-[11px] uppercase tracking-wide text-ink-muted">{inv.roleCode} · expires {String(inv.expiresAt).slice(0, 10)}</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <Button size="sm" variant="outline" disabled={!!busy} onClick={() => reject(inv)} data-testid={`my-invite-reject-${inv.id}`}>Decline</Button>
                <Button size="sm" disabled={!!busy} onClick={() => accept(inv)} data-testid={`my-invite-accept-${inv.id}`}>Accept</Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </Panel>
  );
}
